var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsVisibilityColored(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#c51b8a;}.cls-1{opacity:0.2;}.cls-3{fill:none;stroke:#202349;stroke-linecap:round;stroke-linejoin:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_4",
    "data-name": "Calque 4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 20.54,
    y: 20.9,
    width: 19.7,
    height: 19.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: -0.23,
    y: -0.38,
    width: 19.7,
    height: 19.7
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_3",
    "data-name": "Calque 3"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 20,
    y1: 11.23,
    x2: 20,
    y2: 33.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M20,29.11a13.86,13.86,0,0,0,5.9-11.19A14.84,14.84,0,0,0,20,6.4a14.84,14.84,0,0,0-5.9,11.52A13.86,13.86,0,0,0,20,29.11Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 22.68,
    y1: 12.41,
    x2: 19.97,
    y2: 15.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 16.48,
    y1: 15.13,
    x2: 20,
    y2: 19.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 34.7,
    y1: 17.78,
    x2: 20,
    y2: 33.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M22.7,28.57A12.84,12.84,0,0,0,23,30.43,12.1,12.1,0,0,0,34.47,27c4.9-5.27,3.4-12.64,3.4-12.64a13.23,13.23,0,0,0-10.16,2.21"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 35.81,
    y1: 20.66,
    x2: 31.99,
    y2: 20.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 29.65,
    y1: 17.86,
    x2: 29.09,
    y2: 23.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 5.3,
    y1: 17.78,
    x2: 20,
    y2: 33.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M12.65,16.87a13.13,13.13,0,0,0-10.52-2.5S.63,21.74,5.53,27a12.1,12.1,0,0,0,11.52,3.42,13,13,0,0,0,.28-2.3"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 7.98,
    y1: 16.58,
    x2: 7.98,
    y2: 20.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 5.38,
    y1: 23.22,
    x2: 10.91,
    y2: 23.81
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsVisibilityColored);
export default __webpack_public_path__ + "static/media/icons_visibility_colored.c09eadbcdb9d10bd85084c0967aad4d1.svg";
export { ForwardRef as ReactComponent };